<template>
  <div>
     <stat-info ></stat-info>
     <div class="wallet-detail">
       <div class="wallet-title"><span>Transactions</span></div>
       <div class="wallet-search">
         <el-select v-model="params.status" clearable placeholder="Status">
           <el-option
             v-for="item in statusOptions"
             :key="item.value"
             :label="item.label"
             :value="item.value">
           </el-option>
         </el-select>

         <el-select v-model="params.type" clearable placeholder="Type">
           <el-option
             v-for="item in typeOptions"
             :key="item.value"
             :label="item.label"
             :value="item.value">
           </el-option>
         </el-select>

         <el-date-picker
           v-model="params.dateRange"
           type="daterange"
           range-separator="-"
           value-format="yyyy-MM-dd"
           start-placeholder="Create Start Time"
           end-placeholder="Create End Time">
         </el-date-picker>
       </div>
       <div>
         <el-table
           :data="query.listData"
           stripe
           style="width: 100%"
           size="small"
           :header-cell-style="headerCellStyle"
           :cell-style="cellStyle">

           <el-table-column label="ID/Create Time" align="center">
             <template slot-scope="scope">
               {{scope.row.id}}
               <br/>
               {{handleTime(scope.row.createdAt)}}
             </template>
           </el-table-column>
           <el-table-column label="Amount" align="center">
             <template slot-scope="scope">
              <span :class="{ 'in': scope.row.isInflow, 'out': !scope.row.isInflow }">
                 {{ scope.row.isInflow ? "+" : "-" }}  <span v-format="'$#,##0.00'">{{ scope.row.amount }}</span>
              </span>
             </template>
           </el-table-column>
           <el-table-column label="Status"  align="center">
             <template slot-scope="scope">
             {{transDict("1",scope.row.status)}}
             </template>
           </el-table-column>
           <el-table-column label="Type"  align="center">
             <template slot-scope="scope">
               {{ transDict("2", scope.row.type) }}
             </template>
           </el-table-column>
           <el-table-column label="Received Time" align="center">
             <template slot-scope="scope">
               {{handleTime(scope.row.receiveTime)}}
             </template>
           </el-table-column>
           <el-table-column label="Remark" align="center">
             <template slot-scope="scope">
               {{transDict("2", scope.row.type) }}{{scope.row.id}}
             </template>
           </el-table-column>

         </el-table>
         <Pagination
           style="position: absolute;bottom:0"
           :currentPage="query.currentPage"
           :total="query.total"
           :pageSize="query.pageSize"
           @handleSizeChange="handleSizeChange"
           @handleCurrentChange="handleCurrentChange"
         ></Pagination>
       </div>
    </div>
  </div>
</template>

<script>
/**
 *
 *     @ApiModelProperty(value = " 流转状态  0 待入账 1 已入账   2打款中】")
 *     private Integer status;
 *     @ApiModelProperty(value = " 0 订单商品 1 交易扣点 2物流费 3NT代还款 4提现 5提现手续费 6充值")
 */

const statusOptionArr = [{value: '0', label: 'Pending'}, {value: '1', label: 'Received'}, {value: '2', label: 'Withdraw'}, {value: '3', label: 'Earned'}]
const typeOptionsArr = [{value: '0', label: 'Order Product'}, {value: '1', label: 'Order Commission'}, {value: '2', label: 'Shipping Fee'}, {value: '3',label: 'Net terms Repayment'},{value: '4', label: 'Fund'},{value: '5', label: 'Withdrawal Fee'}]
let statusMapTmp = new Map([ [0, 'Pending'], [1,'Received'], [2, 'Withdraw'],[3, 'Earned'] ])
let typeMapTmp = new Map([ [0, 'Order Product'], [1,'Order Commission'], [2, 'Shipping Fee'],[3,'Net terms Repayment'],[4,'Fund'],[5,'Withdrawal Fee'] ])


import statInfo from "./stat-info";
import Pagination from '../components/pagination.vue'
import { getAction } from '@/api/manage.js'

 export default {
  components: {statInfo,Pagination},
  data() {
    return {
      statusOptions: statusOptionArr,
      typeOptions: typeOptionsArr,
      statusMap: statusMapTmp,
      typeMap: typeMapTmp,
      params:{
        status:"",
        type:"",
        dateRange:"",
      },
      query: {
        listData:[],
        currentPage: 1,
        pageSize: 15,
        total: 0
      },
    }
  },
   created() {
      this.loadData();
   },
   watch:{
     params:{
       handler(val, oldVal){
            this.loadData();
       },
       deep:true
     },
   },
   methods:{
     loadData(){
       let startTime = "", endTime = "";
       if (this.params.dateRange) {
         startTime = this.params.dateRange[0];
         endTime = this.params.dateRange[1];
       }

       getAction("/sp/suppliers/wallet?transactionStatus="+this.params.status+"&type="+this.params.type+"&createStartTime="+startTime+"&createEndTime="+endTime).then((res)=>{
         if (res.success) {
           if (res.result) {
             this.query.total = res.result.total
             this.query.currentPage = res.result.current
             this.query.pageSize = res.result.size
             this.query.listData = res.result.records
           }
         } else {
           this.$message.warning(res.message)
         }
       });
     },
     transDict(type, value) {
       return type=='1'?this.statusMap.get(value):this.typeMap.get(value)
     },
     handleTime(reviewTime) {
       if (!reviewTime) {
         return ""
       }

       let monthValue = reviewTime.monthValue
       let hour = reviewTime.hour
       let minute = reviewTime.minute
       let second = reviewTime.second
       if (monthValue < 10) {
         monthValue = '0' + monthValue
       }
       if (hour < 10) {
         hour = '0' + hour
       }
       if (minute < 10) {
         minute = '0' + minute
       }
       if (second < 10) {
         second = '0' + second
       }
       return reviewTime.year + '/' + monthValue + '/' + reviewTime.dayOfMonth + '  ' + hour + ':' + minute + ':' + second
     },
     handleSizeChange(pageSize) {
       this.query.pageSize = pageSize
       this.query.currentPage = 1
       this.loadData()
     },
     handleCurrentChange(currentPage) {
       this.query.currentPage = currentPage
       this.loadData()
     },
     headerCellStyle({row, column, rowIndex, columnIndex}) {
       return {
         'text-align': 'center',
         'height': '19px',
         'font-size': '14px',
         'font-family': 'Avenir',
         'font-weight': '500',
         'line-height': '38px',
         'color': '#000000',
         'opacity': 1
       }
     },
     cellStyle({row, column, rowIndex, columnIndex}) {
       return {
         'height': '19px',
         'font-size': '12px',
         'font-family': 'Avenir',
         'font-weight': '500',
         'line-height': '20px',
         'color': '#262B2F',
         'opacity': 1

       }
     }


   }


}
</script>

<style lang="less" scoped>
.wallet-detail{
    font-size: 14px;
    font-family: Graphik;
    font-weight: 500;
    color: #262B2F;
    margin-top: 20px;
  .wallet-title{
    font-weight: 800;
    margin-bottom: 10px;
  }

}
.in{color: #41B76A;}
.out{color: #FB541C;}
</style>



// WEBPACK FOOTER //
// src/pages/wallet/index.vue